import React from 'react';
import BottomSheet from './BottomSheet';

// Menu azioni CONDIVISO aperto dal pulsante "+" (scheda + libero):
//  1. Aggiungi esercizio  2. Crea superserie
// "Crea superserie" richiede almeno 2 esercizi già presenti.
function AddActionsSheet({ onClose, onAddExercise, onCreateSuperset, canCreateSuperset }) {
  return (
    <BottomSheet onClose={onClose} closeButton>
      <div className="px-6 pb-8 pt-1">
        <h2 className="text-xl font-bold text-gray-900 mb-4">Aggiungi</h2>

        <button
          type="button"
          onClick={onAddExercise}
          className="w-full flex items-center gap-3 p-4 rounded-xl border border-gray-200 hover:bg-gray-50 transition-colors mb-3 text-left"
        >
          <span className="text-2xl">➕</span>
          <span>
            <span className="block font-semibold text-gray-900">Aggiungi esercizio</span>
            <span className="block text-xs text-gray-500">Cerca e inserisci un nuovo esercizio</span>
          </span>
        </button>

        <button
          type="button"
          onClick={canCreateSuperset ? onCreateSuperset : undefined}
          disabled={!canCreateSuperset}
          className={`w-full flex items-center gap-3 p-4 rounded-xl border text-left transition-colors ${
            canCreateSuperset
              ? 'border-gray-200 hover:bg-gray-50'
              : 'border-gray-100 opacity-50 cursor-not-allowed'
          }`}
        >
          <span className="text-2xl">🔗</span>
          <span>
            <span className="block font-semibold text-gray-900">Crea superserie</span>
            <span className="block text-xs text-gray-500">
              {canCreateSuperset
                ? 'Collega 2 o più esercizi già presenti'
                : 'Servono almeno 2 esercizi'}
            </span>
          </span>
        </button>
      </div>
    </BottomSheet>
  );
}

export default AddActionsSheet;
